(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/content-loader.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/content-loader.js');

'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var imageSizes;
var jupiter;
var logger;
var videoContentLoader;
if (isServer) {
  var trinidad = require('trinidad-core').core;
  jupiter = trinidad.jupiter;
  logger = trinidad.logger('component:content:simple-article');
  imageSizes = trinidad.components.require('content', 'shared').imageSizes;
  videoContentLoader = trinidad.components.require('components', 'video-player');
} else {
  jupiter = {
    call: function call(options, callback) {
      return svs.core.jupiter.call(options, function (data) {
        return callback(null, data);
      }, function (err) {
        return callback(err);
      });
    }
  };
  logger = new svs.core.log.Logger('component:content:simple-article');
  imageSizes = svs.content.shared.imageSizes;
  videoContentLoader = svs.components.video_player.contentLoader;
}

var rollbackHeaderHierarchy = function rollbackHeaderHierarchy() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var stepUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var headerRegex = /<h([1-6])>(.*?)<\/h[1-6]>/gi;
  var h1Count = 0;
  if (html) {
    var modifiedHTML = html.replace(headerRegex, function (match, tagLevel, content) {
      var currentLevel = parseInt(tagLevel, 10);
      var newLevel = stepUp ? currentLevel + 1 : currentLevel - 1;
      if (newLevel === 1) {
        h1Count++;
      }
      if (h1Count > 1) {
        throw new Error('Only one <h1> tag is allowed.');
      }
      var newTagName = "h".concat(newLevel);
      var className = stepUp ? "class=\"h".concat(currentLevel, "\"") : '';
      return "<".concat(newTagName, " ").concat(className, ">").concat(content, "</").concat(newTagName, ">");
    });
    return modifiedHTML;
  }
};

function loadArticle(options, callback) {
  if (!options || !options.url) {
    callback('Required options parameters not supplied');
    return;
  }

  var jupiterOptions = {
    method: 'GET',
    path: options.url,
    req: options.req
  };
  try {
    jupiter.call(jupiterOptions, function (err, data) {
      if (err) {
        callback(err);
      } else if (!data.result[0]) {
        logger.debug('No article in data response', options.req);

        callback(null);
      } else {
        prepareArticles(data.result, options, function (err, result) {
          return callback(err, result[0]);
        });
      }
    });
  } catch (e) {
    callback(e);
  }
}

function loadArticles(options, callback) {
  var count = options.count;
  if (typeof count === 'undefined') {
    logger.warn('Count parameter is missing.');
  }
  if (!options || !options.url) {
    callback('Required options parameters not supplied');
    return;
  }

  var jupiterOptions = {
    method: 'GET',
    path: options.url,
    req: options.req
  };
  try {
    jupiter.call(jupiterOptions, function (err, data) {
      if (err) {
        logger.warn("Failed to fetch articles, url: ".concat(options.url), options.req);
        callback("Failed to fetch articles:".concat(err.message));
      } else if (!data.result[0]) {
        callback(null, []);
      } else {
        prepareArticles(data.result, options, callback);
      }
    });
  } catch (e) {
    callback(e);
  }
}
function prepareImages(images, options) {
  return images.map(function (image) {
    image.sizes = imageSizes.getMediaQuery([imageSizes.ENUM.lg, imageSizes.ENUM.xs]);
    image.noscriptUrl = image.url.replace('{width}', options.fallbackImageWidth || '1280');

    image.heightPercent = 560 / 1280 * 100;
    return image;
  });
}
function prepareVideos(videos) {
  return videos.map(function (video) {
    if (video.type === 'redbee') {
      try {
        return _objectSpread({
          assetId: video.id,
          businessUnit: 'VOD',
          customer: 'SvenskaSpel',
          src: ''
        }, video);
      } catch (error) {
        logger.warn("Error loading redbee video content: ".concat(error.toString()));
      }
    } else {
      var solidtangoVid;
      videoContentLoader.loadVideo({
        api: false,
        type: video.type,
        videoId: video.id,
        title: video.title
      }, function (err, loadedVideo) {
        if (err) {
          logger.warn("Error loading solidtango video content: ".concat(err.toString()));
        } else if (loadedVideo) {
          solidtangoVid = _objectSpread({
            name: video.name
          }, loadedVideo);
        }
      });
      return solidtangoVid;
    }
    return [];
  });
}

function prepareArticles(articles, options, callback) {
  var preparedArticles = articles.map(function (article) {
    var _options$req, _options$req$route, _options$req$route$mo;
    var useH2ForTitle = (options === null || options === void 0 ? void 0 : (_options$req = options.req) === null || _options$req === void 0 ? void 0 : (_options$req$route = _options$req.route) === null || _options$req$route === void 0 ? void 0 : (_options$req$route$mo = _options$req$route.moduleConfig) === null || _options$req$route$mo === void 0 ? void 0 : _options$req$route$mo.useH2ForTitle) || options.useH2ForTitle || article.useH2ForTitle || false;
    if (useH2ForTitle) {
      article.useH2ForTitle = true;
      article.body = rollbackHeaderHierarchy(article.body, true);
    }
    if (article.images) {
      article.images = prepareImages(article.images, options);
    }
    if (article.videos) {
      article.videos = prepareVideos(article.videos);
    }
    article.isInverted = options.isInverted;
    return article;
  });
  callback(null, preparedArticles);
}
if (isServer) {
  module.exports = {
    loadArticle: loadArticle,
    loadArticles: loadArticles,
    prepareArticles: prepareArticles
  };
} else {
  svs.content.simple_article.contentLoader = {
    loadArticle: loadArticle,
    loadArticles: loadArticles,
    prepareArticles: prepareArticles
  };
}

 })(window);